import { Directive, Input, TemplateRef, ViewContainerRef, inject } from '@angular/core';
import { AppType } from '../builder.interface';
import { builderEnvironment } from '../environment/environment';

@Directive({
  selector: '[portalHideInApp]',
  standalone: false,
})
export class HideInAppDirective {
  private readonly templateRef = inject<TemplateRef<object>>(TemplateRef);
  private readonly viewContainerRef = inject(ViewContainerRef);

  @Input()
  set portalHideInApp(v: AppType[]) {
    if (!v.includes(builderEnvironment.appType)) {
      this.viewContainerRef.createEmbeddedView(this.templateRef);

      return;
    }
    this.viewContainerRef.clear();
  }
}
